module.exports = __webpack_public_path__ + "static/media/400017_01.20ba4d55.png";